import { getProjectsApiV2 } from '../../../api/myprojects';
import {
  myprojectsActions,
  myprojectsSelector,
} from '../../../redux/slicers/my-projects/myProjectsSlicer';
import { useThumbnailCardDataList } from '../../../hooks/useDataList';
import { MODEL_TYPES } from '../../../constants/constants';
import { Recent_First_Value } from '../../../constants/filters';

const useProjects = ({
  requestParams,
  filterByKey,
  defaultSort = Recent_First_Value, // '-created_at',
  useGlobalSearch,
  modelType = MODEL_TYPES.PROJECTS,
  filterByOptions,
  useGlobalFilter
}) => {
  const data = useThumbnailCardDataList({
    selector: myprojectsSelector,
    resetAction: myprojectsActions.resetList,
    getAction: getProjectsApiV2,
    itemDeleteText: 'Are you sure you want to delete this project?',
    itemsDeleteText: (selectedIds) =>
      `Are you sure you want to delete ${selectedIds.length} projects?`,
    defaultSort,
    requestParams,
    filterByKey,
    useGlobalFilter,
    useGlobalSearch,
    hookName: 'useProjects',
    modelType,
    filterByOptions,
  });

  return data;
};

export default useProjects;
